/* PROTOCOL DAY — first-touch attribution for Klaviyo signups.
   Captures utm_* / click ids on landing, stores first touch permanently,
   and exposes window.pdAttr(extra) -> flat property object for Klaviyo profiles.
   No PII is stored. Fails silently if storage is unavailable (private mode). */
(function () {
  var KEY = 'pd_attr_v1';
  var FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(o) {
    try { window.localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { /* private mode */ }
  }

  var cur = {};
  try {
    var q = new URLSearchParams(window.location.search);
    FIELDS.forEach(function (k) {
      var v = q.get(k);
      if (v) cur[k] = String(v).slice(0, 120);
    });
  } catch (e) { /* very old browser */ }

  var hasCur = Object.keys(cur).length > 0;
  var stored = read();

  if (!stored) {
    stored = {
      first: cur,
      first_landing: window.location.pathname,
      first_referrer: (document.referrer || '').slice(0, 200),
      first_at: new Date().toISOString()
    };
    write(stored);
  } else if (hasCur) {
    stored.latest = cur;
    write(stored);
  }

  /* 14.10: флаг «почту уже оставили» (pd_lead_v1) — любой успешный POST в Klaviyo client/subscriptions из форм сайта. Его читает попап листа (snippets/pd-lead-popup.liquid). */
  try {
    var origFetch = window.fetch;
    if (origFetch && !origFetch.__pdLead) {
      var wrapped = function (input, init) {
        var p = origFetch.apply(this, arguments);
        try {
          var u = typeof input === 'string' ? input : ((input && input.url) || '');
          var m = (init && init.method) || (input && input.method) || '';
          if (u.indexOf('a.klaviyo.com/client/subscriptions') > -1 && String(m).toUpperCase() === 'POST') {
            p.then(function (r) {
              if (r && (r.ok || r.status === 202)) { try { window.localStorage.setItem('pd_lead_v1', String(Date.now())); } catch (e) {} }
            }, function () {});
          }
        } catch (e) { /* never break a form */ }
        return p;
      };
      wrapped.__pdLead = true;
      window.fetch = wrapped;
    }
  } catch (e) { /* no fetch */ }

  /* Returns Klaviyo profile properties. `extra` (e.g. {source:'advertorial_3am'}) wins. */
  window.pdAttr = function (extra) {
    var s = read() || {};
    var f = s.first || {};
    var l = s.latest || {};
    /* 20.10 M1: первый заход мог быть без меток (органика, прямой), а рекламный клик — позже: тогда utm_* берём из последнего захода с метками (иначе у платного трафика профиль без utm_*) */
    var u = (f.utm_source || f.utm_campaign || f.utm_content) ? f : l;
    var out = {
      ad_angle: f.utm_content || l.utm_content || '',
      utm_source: u.utm_source || '',
      utm_medium: u.utm_medium || '',
      utm_campaign: u.utm_campaign || '',
      utm_content: u.utm_content || '',
      utm_term: u.utm_term || '',
      latest_ad_angle: l.utm_content || '',
      first_touch_landing: s.first_landing || '',
      first_touch_referrer: s.first_referrer || '',
      first_touch_at: s.first_at || '',
      signup_page: window.location.pathname
    };
    Object.keys(out).forEach(function (k) { if (!out[k]) delete out[k]; });
    if (extra) Object.keys(extra).forEach(function (k) { out[k] = extra[k]; });
    return out;
  };
})();
